module.exports = __webpack_public_path__ + "media/4x3/jm-67f96b2f.svg";